import { render, staticRenderFns } from "./DistrictSearch.vue?vue&type=template&id=66987622&scoped=true&"
import script from "./DistrictSearch.vue?vue&type=script&lang=ts&"
export * from "./DistrictSearch.vue?vue&type=script&lang=ts&"
import style0 from "./DistrictSearch.vue?vue&type=style&index=0&id=66987622&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66987622",
  null
  
)

export default component.exports